// import { AuthorizationGetterTypes } from './types';

export const getters = {}